/* ============================================================================
   LIG — The Drawing Board  (<lig-drawing-board>)
   Reads data-api (LIG middleware base) + data-release from the element,
   fetches voteable concepts, renders cards, handles one-vote-per-browser
   voting (optimistic) and free-form idea submission. No theme imports — talks
   only to the middleware /api/wishlist (CORS reflects origin).
   ============================================================================ */
(function () {
  'use strict';
  var PAW = '<svg class="lig-db-paw" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 14.5c-2.3 0-4.2 1.7-4.2 3.6 0 1.3 1 2 2.3 2 .8 0 1.2-.3 1.9-.3s1.1.3 1.9.3c1.3 0 2.3-.7 2.3-2 0-1.9-1.9-3.6-4.2-3.6Z"/><ellipse cx="7.2" cy="11" rx="1.5" ry="2"/><ellipse cx="16.8" cy="11" rx="1.5" ry="2"/><ellipse cx="9.8" cy="8.2" rx="1.3" ry="1.8"/><ellipse cx="14.2" cy="8.2" rx="1.3" ry="1.8"/></svg>';

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function voterToken() {
    var v = '';
    try {
      v = localStorage.getItem('lig_board_voter') || '';
      if (!v) { v = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : 'v' + Date.now() + Math.random().toString(36).slice(2); localStorage.setItem('lig_board_voter', v); }
    } catch (e) { v = 'v' + Date.now(); }
    return v;
  }

  function define() {
    if (window.customElements && customElements.get('lig-drawing-board')) return;

    function LigDrawingBoard() { return Reflect.construct(HTMLElement, [], LigDrawingBoard); }
    LigDrawingBoard.prototype = Object.create(HTMLElement.prototype);
    LigDrawingBoard.prototype.constructor = LigDrawingBoard;

    LigDrawingBoard.prototype.connectedCallback = function () {
      if (this._init) return; this._init = true;
      this.api = (this.getAttribute('data-api') || '').replace(/\/$/, '');
      this.releaseParam = this.getAttribute('data-release') || '';
      this.voter = voterToken();
      this.grid = this.querySelector('[data-db-grid]');
      this.tally = this.querySelector('[data-db-tally]');
      this.releaseBand = this.querySelector('[data-db-release]');
      this.concepts = [];
      // deep-link override: ?release=slug wins over the section setting
      try { var p = new URLSearchParams(location.search).get('release'); if (p) this.releaseParam = p; } catch (e) {}
      this.wireForm();
      this.load();
    };

    LigDrawingBoard.prototype.load = function () {
      var self = this;
      var qs = '?voter=' + encodeURIComponent(this.voter) + (this.releaseParam ? '&bucket=' + encodeURIComponent(this.releaseParam) : '');
      fetch(this.api + '/api/wishlist' + qs).then(function (r) { return r.json(); }).then(function (d) {
        if (!d || !d.ok) throw new Error('load');
        self.bucket = d.bucket;
        self.concepts = d.concepts || [];
        if (d.release) self.renderRelease(d.release);
        self.renderGrid();
        self.renderTally();
      }).catch(function () {
        if (self.grid) self.grid.innerHTML = '<div class="lig-db-empty">We couldn\'t load the board just now — please refresh in a moment.</div>';
      });
    };

    LigDrawingBoard.prototype.renderRelease = function (rel) {
      if (!this.releaseBand) return;
      var lab = this.releaseBand.querySelector('[data-db-rel-label]');
      var blb = this.releaseBand.querySelector('[data-db-rel-blurb]');
      if (lab) lab.textContent = rel.label || '';
      if (blb) blb.textContent = rel.blurb || '';
      this.releaseBand.hidden = false;
    };

    LigDrawingBoard.prototype.renderTally = function () {
      if (!this.tally) return;
      var t = this.concepts.reduce(function (a, c) { return a + (c.votes || 0); }, 0);
      this.tally.textContent = t.toLocaleString();
    };

    LigDrawingBoard.prototype.renderGrid = function () {
      var self = this, g = this.grid; if (!g) return;
      if (!this.concepts.length) {
        g.innerHTML = '<div class="lig-db-empty">Fresh concepts are on their way — check back soon, and drop your own idea below in the meantime. 🐾</div>';
        return;
      }
      var ranked = this.concepts.slice().sort(function (a, b) { return (b.votes || 0) - (a.votes || 0); });
      var topId = (ranked.length && ranked[0].votes > 0) ? ranked[0].id : null;
      g.innerHTML = this.concepts.map(function (c) {
        var media = c.image_url
          ? '<img src="' + esc(c.image_url) + '" alt="' + esc(c.title) + '" loading="lazy" />'
          : '<span class="lig-db-card__ph">Concept</span>';
        var ribbon = (c.id === topId) ? '<span class="lig-db-ribbon">★ Pack favorite</span>' : '';
        return '<article class="lig-db-card" data-id="' + esc(c.id) + '">'
          + '<div class="lig-db-card__media">' + ribbon + media + '</div>'
          + '<div class="lig-db-card__body">'
          + '<h3 class="lig-db-card__title">' + esc(c.title) + '</h3>'
          + '<p class="lig-db-card__sub">' + esc(c.subtitle || '') + '</p>'
          + '<button type="button" class="lig-db-vote-btn' + (c.voted ? ' is-voted' : '') + '" data-vote="' + esc(c.id) + '" aria-pressed="' + (c.voted ? 'true' : 'false') + '">'
          + PAW + '<span class="lig-db-lbl">' + (c.voted ? 'Loved' : 'I want this') + '</span> <span class="lig-db-n">' + (c.votes || 0) + '</span>'
          + '</button>'
          + '</div></article>';
      }).join('');
      var cards = g.querySelectorAll('.lig-db-card');
      cards.forEach(function (el, i) { setTimeout(function () { el.classList.add('is-in'); }, 60 + i * 60); });
      g.querySelectorAll('[data-vote]').forEach(function (b) { b.addEventListener('click', function () { self.toggleVote(b); }); });
    };

    LigDrawingBoard.prototype.toggleVote = function (btn) {
      var self = this, id = btn.getAttribute('data-vote');
      var c = this.concepts.filter(function (x) { return x.id === id; })[0];
      if (!c || btn.disabled) return;
      var was = !!c.voted;
      c.voted = !was; c.votes = Math.max(0, (c.votes || 0) + (was ? -1 : 1));
      this.paintVote(btn, c);
      if (!was) { btn.classList.add('is-pop'); setTimeout(function () { btn.classList.remove('is-pop'); }, 220); }
      this.renderTally();
      btn.disabled = true;
      fetch(this.api + '/api/wishlist', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ action: was ? 'unvote' : 'vote', conceptId: id, voter: this.voter }) })
        .then(function (r) { return r.json(); }).then(function (d) {
          if (d && typeof d.votes === 'number') { c.votes = d.votes; c.voted = !!d.voted; self.paintVote(btn, c); self.renderTally(); }
        }).catch(function () {
          c.voted = was; c.votes = Math.max(0, (c.votes || 0) + (was ? 1 : -1)); self.paintVote(btn, c); self.renderTally();
        }).finally(function () { btn.disabled = false; });
    };

    LigDrawingBoard.prototype.paintVote = function (btn, c) {
      btn.classList.toggle('is-voted', !!c.voted);
      btn.setAttribute('aria-pressed', c.voted ? 'true' : 'false');
      var lbl = btn.querySelector('.lig-db-lbl'); if (lbl) lbl.textContent = c.voted ? 'Loved' : 'I want this';
      var n = btn.querySelector('.lig-db-n'); if (n) n.textContent = c.votes || 0;
    };

    LigDrawingBoard.prototype.wireForm = function () {
      var self = this;
      var form = this.querySelector('[data-db-form]'); if (!form) return;
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var text = (form.querySelector('[data-db-text]').value || '').trim();
        if (text.length < 3) return;
        var email = (form.querySelector('[data-db-email]').value || '').trim();
        var hp = (form.querySelector('[data-db-hp]') || {}).value || '';
        var btn = form.querySelector('[data-db-submit]');
        btn.disabled = true; btn.setAttribute('aria-busy', 'true'); var orig = btn.textContent; btn.textContent = 'Sending…';
        fetch(self.api + '/api/wishlist', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ action: 'comment', text: text, email: email, bucket: self.bucket || self.releaseParam || '', website: hp }) })
          .then(function (r) { return r.json(); }).then(function (d) {
            if (!d || !d.ok) throw new Error();
            form.hidden = true;
            var t = self.querySelector('[data-db-thanks]');
            if (t) { t.hidden = false; t.innerHTML = 'Got it — thank you. 🐾<br>Your idea is on the board now. The best ones become real.'; }
          }).catch(function () {
            btn.disabled = false; btn.removeAttribute('aria-busy'); btn.textContent = orig;
            alert("Hmm, that didn't go through — mind trying once more?");
          });
      });
    };

    window.customElements.define('lig-drawing-board', LigDrawingBoard);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', define);
  else define();
})();
